export class NhanSuKhac {
    "id": number;
    "hoTen": string;
    "ma": string;
    "idNhanVien": number | null;
    "idChucVu": number;
    "idNhomNhanSu": number;
    "tenChucVu": string;
    "trangThai": number;
    "tuNgay": Date | null;
    "denNgay": Date | null;
    "thuTu": number;
}

export class NhanSuKhacRequest {
    "id": number;
    "hoTen": string;
    "ma": string;
    "idNhanVien": number | null;
    "idChucVu": number;
    "thuTu": number;
    "idNhomNhanSu": number;
    "trangThai": number;
    "tuNgay": Date | null;
    "denNgay": Date | null;
}

export class LuongKhenThuongNhanSuKhacResponse {
    "idNhanSuKhac": number;
    "id": number;
    "hoTen": string;
    "tenChucVu": string;
    "tenDonVi": string;
    "mucTien": number;
    "soTienThuePhaiDong"?: number;
    "soTienThueDaDong"?: number;
};

export class DanhSachKhenThuongNhanSuKhacResponse {
    "ten": string;
    "khoaDieuChinh": number;
    "id": number;
    "soLuongCBCNV": number
};

export class ChiTietKhenThuongNhanSuKhacResponse {
    "ten": string;
    "khoaDieuChinh": number;
    "id": number;
    "dsNhanVien": Array<LuongKhenThuongNhanSuKhacResponse>
}